import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fe5b6432")

_pushScopeId("data-v-fe5b6432")
const _hoisted_1 = { class: "add-tags-modal" }
const _hoisted_2 = { class: "tags-modal-header" }
const _hoisted_3 = { class: "fs-16" }
const _hoisted_4 = { class: "tags-modal-create-panel" }
const _hoisted_5 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "search-button-wrapper" }, [
  /*#__PURE__*/_createVNode("button", null, [
    /*#__PURE__*/_createVNode("i", { class: "icon-f icon-search fs-24" })
  ])
], -1)
const _hoisted_7 = { class: "tag-items-div" }
const _hoisted_8 = { class: "tag-items" }
const _hoisted_9 = {
  class: "tag-item p-0",
  style: {"padding-inline-start":"5px"}
}
const _hoisted_10 = { class: "modal-down" }
const _hoisted_11 = {
  class: "row d-flex justify-content-between justify-content-lg-center",
  style: {"column-gap":"10px","padding-top":"20px"}
}
const _hoisted_12 = { class: "my-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CheckBoxInput = _resolveComponent("CheckBoxInput")
  const _component_OverlayModal = _resolveComponent("OverlayModal")

  return (_openBlock(), _createBlock(_component_OverlayModal, {
    isOpen: _ctx.isOpen,
    closeOnClick: true,
    onClose: _ctx.close,
    class: "modal-limit pt-5",
    modalWidth: 400
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('label.add-tags')), 1),
          _createVNode("span", {
            class: "icon-f icon-delete-cross c-grey fs-16",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          })
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _withDirectives(_createVNode("input", {
              style: {"height":"40px","margin-inline-end":"15px"},
              type: "text",
              maxlength: "100",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchTagName = $event)),
              class: "form-control w-100",
              placeholder: _ctx.$t('label.tag-name')
            }, null, 8, ["placeholder"]), [
              [
                _vModelText,
                _ctx.searchTagName,
                void 0,
                { trim: true }
              ]
            ]),
            _hoisted_6
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredTags, (tag) => {
              return (_openBlock(), _createBlock("div", {
                key: tag.id
              }, [
                _createVNode("div", _hoisted_9, [
                  _createVNode(_component_CheckBoxInput, {
                    value: tag.id,
                    modelValue: _ctx.selectedTagIds,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedTagIds = $event)),
                    singleLine: true
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(tag.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "modelValue"])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode("button", {
              type: "button",
              class: "close-button-wrapper tags-modal-footer-button px-5",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
            }, _toDisplayString(_ctx.$t('button.cancel')), 1),
            _createVNode("button", {
              type: "button",
              class: "save-button-wrapper tags-modal-footer-button px-5",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onSave && _ctx.onSave(...args)))
            }, [
              _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('button.save')), 1)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen", "onClose"]))
})